import { createPortal } from "react-dom";

export const topFilterWrapper = (topFilter) => {
  const filterTarget: any = document.getElementById("filter_target");
  return <> {filterTarget && createPortal(topFilter, filterTarget)}</>;
};
